import { render, staticRenderFns } from "./DesignOppositionResponsibleForm.vue?vue&type=template&id=3b4202b8&"
import script from "./DesignOppositionResponsibleForm.vue?vue&type=script&lang=js&"
export * from "./DesignOppositionResponsibleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports